module.exports = __webpack_public_path__ + "img/connect-domain-dark.4e168a68.svg";